import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../../shared/services/authorization.service';

@Injectable()
export class AdminAuthorizationCanActivateGuard implements CanActivate {
  constructor(
    private _authorize: AuthorizationService,
    private _router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._authorize.getIsAdminAuthorized().then((result: boolean) => {
      return result || this._router.parseUrl('page-not-found');
    });
  }
}
